export enum WidgetType {
  PRODUCT_PRICE_SUMMARY = 'PRODUCT_PRICE_SUMMARY',
  BANNER = 'BANNER',
  RATING = 'RATING',
  REVIEW_IMAGES = 'REVIEW_IMAGES',
  MULTIMEDIA = 'MULTIMEDIA',
  BREADCRUMBS = 'BREADCRUMBS',
  ICON = 'ICON',
  BUTTON = 'BUTTON',
  IB_COIN_INFO_AND_REVIEW_AND_RATINGS = 'IB_COIN_INFO_AND_REVIEW_AND_RATINGS',
  EMI_OPTIONS = 'EMI_OPTIONS',
  OFFERS_AND_COUPONS = 'OFFERS_AND_COUPONS',
  GSTIN_VERIFICATION = 'GSTIN_VERIFICATION',
  PDP_MORE_PRODUCTS_OPTIONS = 'PDP_MORE_PRODUCTS_OPTIONS',
  PRODUCT_FEATURES = 'PRODUCT_FEATURES',
  COMPOSED_RATING_REVIEW = 'COMPOSED_RATING_REVIEW',
  REVIEW = 'REVIEW',
  QUANTITY_CHANGE = 'QUANTITY_CHANGE',
  BULK_QUANTITY_DISCOUNT = 'BULK_QUANTITY_DISCOUNT',
  CHECK_DELIVERY_DETAILS = 'CHECK_DELIVERY_DETAILS',
  CATEGORY_SUMMARY = 'CATEGORY_SUMMARY',
  PRICE_RANGE = 'PRICE_RANGE',
  CATEGORIES = 'CATEGORIES',
  BRANDS = 'BRANDS',
  DISCOUNT = 'DISCOUNT',
  AVAILABILITY = 'AVAILABILITY',
  SORT_BY = 'SORT_BY',
  SEARCH_PRODUCTS_COUNT = 'SEARCH_PRODUCTS_COUNT',
  PLP_FILTERS = 'PLP_FILTERS',
  PLP_TOP = 'PLP_TOP',
  PLP_HEAD = 'PLP_HEAD',
  PLP_DROPDOWNS = 'PLP_DROPDOWNS',
  PLP_PRODUCTS_LIST = 'PLP_PRODUCTS_LIST',
  VIEW_ALL = 'VIEW_ALL',
  CAROUSEL_BANNER = 'CAROUSEL_BANNER',
  CAT_CARD_GRID = 'CAT_CARD_GRID',
  PRODUCT_LIST = 'PRODUCT_LIST',
  CREATIVE_CARD = 'CREATIVE_CARD',
  OMU = 'OMU',
  PMU_V2 = 'PMU_V2',
  ADS_V2 = 'ADS_V2',
  TEXT_CARD = 'TEXT_CARD',
  SEO = 'SEO',
  PRODUCT_CARD = 'PRODUCT_CARD',
  FAMILY_ATTRIBUTES = 'FAMILY_ATTRIBUTES',
  PRODUCT_PAGE_SUMMARY = 'PRODUCT_PAGE_SUMMARY',
  PRODUCT_OFFERS = 'PRODUCT_OFFERS',
  FAMILY_ITEMS = 'FAMILY_ITEMS',

  DELIVERY_ADDRESS = 'DELIVERY_ADDRESS',
  CART_PAGE_BILLING_ADDRESS = 'CART_PAGE_BILLING_ADDRESS',
  CART_PAGE_SHIPPING_ADDRESS = 'CART_PAGE_SHIPPING_ADDRESS',
  ADD_MORE_ADDRESS = 'ADD_MORE_ADDRESS',

  TRANSACT_PRICE_SUMMARY = 'TRANSACT_PRICE_SUMMARY',
  TRANSACT_ACTION = 'TRANSACT_ACTION',
  PRODUCT_SUMMARY_LIST = 'PRODUCT_SUMMARY_LIST',
  PRODUCT_SUMMARY_GRID = 'PRODUCT_SUMMARY_GRID',
  NO_PRODUCTS_FOUND = 'NO_PRODUCTS_FOUND',
  AD = 'AD',
  REQUEST_CALLBACK = 'REQUEST_CALLBACK',
  TEXT = 'TEXT',
  EXPLORE_OTHER_CATEGORIES = 'EXPLORE_OTHER_CATEGORIES',
  LIST_GRID = 'LIST_GRID',
  HEADER_CONTENT = 'HEADER_CONTENT',
  REVIEW_AND_RATINGS = 'REVIEW_AND_RATINGS',
  OVERALL_RATINGS = 'OVERALL_RATINGS',
  SHARE_YOUR_THOUGHTS = 'SHARE_YOUR_THOUGHTS',
  AUTOSUGGEST_PARTITION_WIDGET = 'AUTOSUGGEST_PARTITION_WIDGET',
  AUTOSUGGEST_QUERY_WIDGET = 'AUTOSUGGEST_QUERY_WIDGET',
  AUTOSUGGEST_TRENDING_WIDGET = 'AUTOSUGGEST_TRENDING_WIDGET',
  AUTOSUGGEST_HISTORY_WIDGET = 'AUTOSUGGEST_HISTORY_WIDGET',
  AUTOSUGGEST_CARD_WIDGET = 'AUTOSUGGEST_CARD_WIDGET',
  OUT_OF_STOCK_FORM = 'OUT_OF_STOCK_FORM',
  FILTERS_SORT_BY = 'FILTERS_SORT_BY',
  CART_PRICE_SUMMARY = 'CART_PRICE_SUMMARY',
  CALLOUT_WITH_ACTION = 'CALLOUT_WITH_ACTION',
  TEXT_HEADING = 'TEXT_HEADING',
  DYNAMIC_INPUT = 'DYNAMIC_INPUT',
  EMPTY_SEARCH = 'EMPTY_SEARCH',

  GST_WIDGET = 'GST_WIDGET',
  ALL_CATEGORIES = 'ALL_CATEGORIES',
  NONE = 'NONE',

  /**
   * PAYMENT PAGE RELATED WIDGETS
   */
  PAYMENT_STAGE = 'PAYMENT_STAGE',

  // user profile page widgets
  ICON_WITH_TEXT_LIST = 'ICON_WITH_TEXT_LIST',
  PROFILE_CARD = 'PROFILE_CARD',
  ORDER_VIEWER = 'ORDER_VIEWER',
  ADDRESS = 'ADDRESS',
  ADDRESS_FORM = 'ADDRESS_FORM',
  PASSWORD_CHANGER = 'PASSWORD_CHANGER',

  // user profile page widget ends
  TESTIMONIAL = 'TESTIMONIAL',
  ALL_BRAND_CATEGORIES = 'ALL_BRAND_CATEGORIES',
  ATLAS_WIDGET = 'ATLAS_WIDGET',

  THANK_YOU_PAGE_OPTIONS = 'THANK_YOU_PAGE_OPTIONS',
  DROPDOWN = 'DROPDOWN',
  SEARCH_BAR = 'SEARCH_BAR',
  REUSABLE_PAGINATION_BAR = 'REUSABLE_PAGINATION_BAR',
  GST_INFO_CARD = 'GST_INFO_CARD',
  TABLE_CONTENT = 'TABLE_CONTENT',

  RETURNS_TABLE = 'RETURNS_TABLE',
  MEDIA_UPLOAD = 'MEDIA_UPLOAD',

  FAMILY_PRODUCT_CARD = 'FAMILY_PRODUCT_CARD',

  BANK_ACCOUNT_VIEWER = 'BANK_ACCOUNT_VIEWER',
  BANK_ACCOUNT_FORM = 'BANK_ACCOUNT_FORM',
  ORDER_STATE_PRODUCT_CARD = 'ORDER_STATE_PRODUCT_CARD',

  REVIEW_PROGRESS_BAR = 'REVIEW_PROGRESS_BAR',
  REVIEW_CARD = 'REVIEW_CARD',
  REVIEW_VIEWER = 'REVIEW_VIEWER',

  FORM = 'FORM',
  FIXED_BOTTOM_BAR = 'FIXED_BOTTOM_BAR',
  FIXED_FEATURES_SPECIFICATIONS = 'FIXED_FEATURES_SPECIFICATIONS',
  FAMILY_PRODUCT_LISTING = 'FAMILY_PRODUCT_LISTING',
  ACCORDION = 'ACCORDION',
  SIDE_BAR = 'SIDE_BAR',
  WHATSAPP_CHAT = 'WHATSAPP_CHAT',
  HIGH_VALUE_PDP = 'HIGH_VALUE_PDP',
  DIVIDER = 'DIVIDER',
  APP_INSTALL_BANNER = 'APP_INSTALL_BANNER',
  CUSTOMER_HELPLINE_OPTIONS = 'CUSTOMER_HELPLINE_OPTIONS',

  // ib-credit-order-card
  IB_CREDIT_ORDER_CARD = 'IB_CREDIT_ORDER_CARD',
  IB_CREDIT_PAYMENT_DETAIL_CARD = 'IB_CREDIT_PAYMENT_DETAIL_CARD',

  // custom pricing / quotation card
  CUSTOM_PRICING = 'CUSTOM_PRICING',

  // user quote
  USER_QUOTE = 'USER_QUOTE',
  NPS_THANK_YOU_SUBMISSION = 'NPS_THANK_YOU_SUBMISSION',

  // IB Credit static section
  IB_CREDIT_HOW_IT_WORK = 'IB_CREDIT_HOW_IT_WORK',
  IB_CREDIT_PAYMENT = 'IB_CREDIT_PAYMENT',

  REVIEW_PAGE = 'REVIEW_PAGE',
  REVIEW_CARD_REDIRECT = 'REVIEW_CARD_REDIRECT',

  // grievance redressal
  GRIEVANCE_REDRESSAL = 'GRIEVANCE_REDRESSAL',
  FAQS = 'FAQS',

  PDP_MEDIA = 'PDP_MEDIA',
  IB_CREDIT_ELIGIBILITY = 'IB_CREDIT_ELIGIBILITY',
}
